import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  const fetchData = () => {
    api.get('/messages').then(r => setMessages(r.data));
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  const filtered = messages.filter(m => {
    const matchStatus = filter === 'all' || m.status === filter;
    const matchSearch = m.phone?.includes(search) || m.order_id?.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  return (
    <div>
      <div className="box">
        <div style={{display:'flex',gap:'12px',marginBottom:'16px',alignItems:'center'}}>
          <h3 style={{marginBottom:0}}>Message Logs</h3>
          <input
            placeholder="Search phone or order ID..."
            value={search}
            onChange={e=>setSearch(e.target.value)}
            style={{padding:'7px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',width:'240px'}}
          />
          <select value={filter} onChange={e=>setFilter(e.target.value)}
            style={{padding:'7px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
            <option value="all">All Status</option>
            <option value="sent">Sent</option>
            <option value="delivered">Delivered</option>
            <option value="read">Read</option>
            <option value="failed">Failed</option>
          </select>
          <span style={{marginLeft:'auto',fontSize:'13px',color:'#888'}}>{filtered.length} records</span>
          <span style={{fontSize:'12px',color:'#aaa'}}>Auto refreshes every 30s</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Phone</th>
              <th>Order ID</th>
              <th>Template</th>
              <th>Status</th>
              <th>Cost</th>
              <th>Sent At</th>
              <th>Delivered At</th>
              <th>Read At</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan="9" style={{textAlign:'center',color:'#aaa',padding:'32px'}}>No messages found</td></tr>
            )}
            {filtered.map((m, i) => (
              <tr key={m.id}>
                <td>{i+1}</td>
                <td>{m.phone}</td>
                <td>{m.order_id || '-'}</td>
                <td style={{fontSize:'11px',color:'#666'}}>{m.template_name}</td>
                <td><span className={`badge ${m.status}`}>{m.status}</span></td>
                <td>₹{parseFloat(m.cost||0).toFixed(4)}</td>
                <td>{m.sent_at ? new Date(m.sent_at).toLocaleString('en-IN') : '-'}</td>
                <td>{m.delivered_at ? new Date(m.delivered_at).toLocaleString('en-IN') : '-'}</td>
                <td>{m.read_at ? new Date(m.read_at).toLocaleString('en-IN') : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
